var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.forLoop),function(loop,index){return _c('li',{key:index},[_vm._v("\n\t\t\t"+_vm._s(loop)+"\n\t\t")])}))])}
var staticRenderFns = []

export { render, staticRenderFns }